module.exports = __webpack_public_path__ + "media/derect_tutorial_intro.4aaf4ee0.mp4";